import request from '../base-service';
import type { InternalAxiosRequestConfig } from 'axios';
import type { GuideListPayload } from '@/types/guide';
const BASE_URL = '/v1/VHWebPart';

export const vhWebPartApi = {
  /** Đồng bộ BSC `POST /v1/guide/list` — toàn bộ cây VH_HuongDans. */
  list: (payload: GuideListPayload) =>
    request.post(`${BASE_URL}/list`, payload, {
      authorization: true,
    } as InternalAxiosRequestConfig),

  /** Đồng bộ BSC `POST /v1/guide/gethuongdansudung` — DB VH_HuongDans, response `HuongDanViewDto`. */
  getHuongDanSuDung: (payload: GuideListPayload) =>
    request.post(`${BASE_URL}/gethuongdansudung`, payload, {
      authorization: true,
    } as InternalAxiosRequestConfig),
};
